/* Nailelf Custom PDP V10 — native product form / automatic app matching — lightweight interactions for Dawn */
(() => {
  const init = (root) => {
    if (!root || root.dataset.nelReady === 'true') return;
    root.dataset.nelReady = 'true';
    const $ = (selector, scope = root) => scope.querySelector(selector);
    const $$ = (selector, scope = root) => Array.from(scope.querySelectorAll(selector));

    /* Remove duplicate legacy breadcrumb injected above the V10 PDP. */
    document.querySelectorAll('nav.nel-breadcrumbs.page-width').forEach((breadcrumb) => breadcrumb.remove());

    /* Product gallery */
    const mediaButtons = $$('[data-nel-media]');
    const mediaSlides = $$('[data-nel-slide]');
    const mediaDots = $$('[data-nel-media-dot]');
    mediaButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.dataset.nelMedia;
        mediaButtons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
        });
        mediaSlides.forEach((slide) => {
          const active = slide.dataset.nelSlide === target;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        mediaDots.forEach((dot) => {
          dot.classList.toggle('is-active', dot.dataset.nelMediaDot === target);
        });
      });
    });


    /* Product-only image gallery */
    const productGallery = $('[data-nel-product-gallery]');
    if (productGallery) {
      const productSlides = $$('[data-nel-product-slide]', productGallery);
      const productSelectors = $$('[data-nel-product-dot], [data-nel-product-thumb]', productGallery);
      const selectorIndex = (selector) => selector.dataset.nelProductThumb || selector.dataset.nelProductDot;
      const activateProductImage = (index) => {
        productSlides.forEach((slide) => {
          const active = slide.dataset.nelProductSlide === String(index);
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        productSelectors.forEach((selector) => {
          const active = selectorIndex(selector) === String(index);
          selector.classList.toggle('is-active', active);
          selector.classList.toggle('active', active);
          selector.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };
      productSelectors.forEach((selector) => {
        selector.addEventListener('click', () => activateProductImage(selectorIndex(selector)));
      });
    }

    /* Wishlist visual feedback only. Connect to wishlist app separately if required. */
    const wish = $('[data-nel-wishlist]');
    if (wish) {
      wish.addEventListener('click', () => {
        const active = wish.classList.toggle('is-active');
        wish.textContent = active ? '♥' : '♡';
        wish.setAttribute('aria-label', active ? 'Saved to wishlist' : 'Save to wishlist');
      });
    }

    /* Four-step non-editable demonstration */
    const demo = $('[data-nel-demo]');
    if (demo) {
      const scenes = $$('[data-nel-scene]', demo);
      const images = $$('[data-nel-demo-image]', demo);
      const demoImagesWrap = $('.nel-v10__demo-images', demo);
      const bars = $$('.nel-v10__progress i', demo);
      const count = $('[data-nel-demo-count]', demo);
      const caption = $('[data-nel-demo-caption]', demo);
      const subtitle = $('[data-nel-demo-subtitle]', demo);
      const nextButtons = $$('[data-nel-demo-next]', demo);
      const labels = [
        'Step 01 — Choose Nail Shape',
        'Step 02 — Upload Image',
        'Step 03 — Choose Size / Custom Size',
        'Step 04 — Add to Cart'
      ];
      const descriptions = [
        'Example: select the nail silhouette',
        'Example: add the image you want to customize',
        'Example: choose standard or custom sizing',
        'Example: review the result before checkout'
      ];
      let active = 0;
      let timer;
      let paused = false;
      const speed = Math.max(1000, Number(root.dataset.demoSpeed) || 1500);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const fixedRatios = {
        '1-1': '1 / 1',
        '3-4': '3 / 4',
        '4-3': '4 / 3',
        '9-16': '9 / 16'
      };
      const syncDemoImageRatio = () => {
        if (!demoImagesWrap || !images[active]) return;
        const image = images[active];
        const format = image.dataset.nelDemoFormat || 'auto';
        const naturalRatio = Number(image.dataset.nelDemoNaturalRatio) || 1;
        const ratio = fixedRatios[format] || `${naturalRatio} / 1`;
        demoImagesWrap.style.setProperty('--nel-demo-active-ratio', ratio);
        demoImagesWrap.dataset.nelDemoActiveFormat = format;
      };

      const show = (index) => {
        active = (index + scenes.length) % scenes.length;
        scenes.forEach((scene, i) => {
          const selected = i === active;
          scene.classList.toggle('is-active', selected);
          scene.setAttribute('aria-hidden', String(!selected));
        });
        images.forEach((image, i) => {
          const selected = i === active;
          image.classList.toggle('is-active', selected);
          image.setAttribute('aria-hidden', String(!selected));
        });
        bars.forEach((bar, i) => {
          bar.classList.toggle('is-active', i === active);
          bar.classList.toggle('is-done', i < active);
        });
        if (caption) caption.textContent = labels[active];
        if (subtitle) subtitle.textContent = descriptions[active];
        if (count) count.textContent = `Image 0${active + 1} / 04`;
        syncDemoImageRatio();
      };
      const schedule = () => {
        window.clearTimeout(timer);
        if (reduceMotion || paused) return;
        timer = window.setTimeout(() => {
          show(active + 1);
          schedule();
        }, speed);
      };
      nextButtons.forEach((button) => button.addEventListener('click', () => {
        show(Math.min(active + 1, scenes.length - 1));
        schedule();
      }));
      demo.addEventListener('pointerenter', () => {
        if (window.matchMedia('(hover: hover)').matches) {
          paused = true;
          window.clearTimeout(timer);
        }
      });
      demo.addEventListener('pointerleave', () => {
        paused = false;
        schedule();
      });
      demo.addEventListener('focusin', () => {
        paused = true;
        window.clearTimeout(timer);
      });
      demo.addEventListener('focusout', (event) => {
        if (!demo.contains(event.relatedTarget)) {
          paused = false;
          schedule();
        }
      });
      show(0);
      schedule();
    }

    /* Transformation case gallery: tabs, arrows, keyboard and touch swipe */
    const proofRoots = $$('[data-nel-proof]');
    proofRoots.forEach((proof) => {
      const section = proof.closest('.nel-v10--proof-vertical') || proof.closest('.nel-v10') || proof;
      const tabs = $$('[data-nel-proof-tab]', section);
      const panels = $$('[data-nel-proof-panel]', section);
      const dots = $$('.nel-v10__dots i', section);
      const indexLabel = $('[data-nel-proof-index]', section);
      const title = $('[data-nel-proof-title]', section);
      const description = $('[data-nel-proof-desc]', section);
      const switcher = $('.nel-v10__proof-switch', section) || $('.nel-v10__proof-stage-panels', section);
      let active = 0;
      let touchStart = null;

      const show = (index) => {
        if (!panels.length) return;
        active = (index + panels.length) % panels.length;
        tabs.forEach((tab, i) => {
          const selected = i === active;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', String(selected));
        });
        panels.forEach((panel, i) => {
          const selected = i === active;
          panel.classList.toggle('is-active', selected);
          panel.setAttribute('aria-hidden', String(!selected));
        });
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
        const panel = panels[active];
        if (title && panel) title.textContent = panel.dataset.title || '';
        if (description && panel) description.textContent = panel.dataset.description || '';
        if (indexLabel) indexLabel.textContent = `${String(active + 1).padStart(2, '0')} / ${String(panels.length).padStart(2, '0')}`;
      };

      tabs.forEach((tab, index) => tab.addEventListener('click', () => show(index)));
      const previous = $('[data-nel-proof-prev]', section);
      const next = $('[data-nel-proof-next]', section);
      if (previous) previous.addEventListener('click', () => show(active - 1));
      if (next) next.addEventListener('click', () => show(active + 1));
      if (switcher) {
        switcher.setAttribute('tabindex', switcher.getAttribute('tabindex') || '0');
        switcher.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') show(active - 1);
          if (event.key === 'ArrowRight') show(active + 1);
        });
        switcher.addEventListener('touchstart', (event) => {
          touchStart = event.changedTouches[0].clientX;
        }, { passive: true });
        switcher.addEventListener('touchend', (event) => {
          if (touchStart === null) return;
          const delta = event.changedTouches[0].clientX - touchStart;
          if (Math.abs(delta) > 42) show(active + (delta < 0 ? 1 : -1));
          touchStart = null;
        }, { passive: true });
      }
      show(0);
    });

    /* One-open-at-a-time FAQ */
    const faqItems = $$('.nel-v10__faq-list details');
    faqItems.forEach((item) => item.addEventListener('toggle', () => {
      if (!item.open) return;
      faqItems.forEach((other) => {
        if (other !== item) other.open = false;
      });
    }));

    /* Secondary CTA links open the installed CustoMeow customizer.
       If the app has not finished rendering, fall back to the customizer block and retry. */
    const primaryForm = $('[data-nel-native-product-form]') || document.querySelector('[data-nel-native-product-form]');
    const findCustomeowButton = () => {
      const selectors = [
        'customeow-block-button .customeow-block-btn-add:not([disabled])',
        '.customeow-block-btn-add:not([disabled])',
        'customeow-block-button button:not([disabled])'
      ];
      for (const selector of selectors) {
        const candidates = Array.from(document.querySelectorAll(selector));
        const button = candidates.find((node) => node.offsetParent !== null || node.getClientRects().length);
        if (button) return button;
      }
      return null;
    };
    const openCustomeow = () => {
      const button = findCustomeowButton();
      if (!button) return false;
      button.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => button.click(), 260);
      return true;
    };


    /* OPENCLAW DAWN-1 DIRECT CUSTOMEOW ENTRY 20260729 START
       Homepage Clan CTAs add open_customizer=1. On arrival, wait for the app
       block to render and trigger its real customization button once. */
    const shouldAutoOpenCustomeow = (() => {
      try {
        return new URLSearchParams(window.location.search).get('open_customizer') === '1';
      } catch (error) {
        return false;
      }
    })();
    if (shouldAutoOpenCustomeow && !window.__nelCustomeowDirectEntryScheduled) {
      window.__nelCustomeowDirectEntryScheduled = true;
      let directEntryAttempt = 0;
      const launchDirectCustomeowEntry = () => {
        directEntryAttempt += 1;
        if (openCustomeow()) {
          try {
            const cleanUrl = new URL(window.location.href);
            cleanUrl.searchParams.delete('open_customizer');
            window.history.replaceState({}, '', `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`);
          } catch (error) {
            /* Keep the current URL if History API cleanup is unavailable. */
          }
          return;
        }
        const app = document.querySelector('[data-nel-hero-customeow-app], .nel-hero__customeow-app');
        if (directEntryAttempt === 1) app?.scrollIntoView({ behavior: 'auto', block: 'center' });
        if (directEntryAttempt < 12) {
          window.setTimeout(launchDirectCustomeowEntry, directEntryAttempt < 5 ? 500 : 900);
        }
      };
      window.setTimeout(launchDirectCustomeowEntry, 300);
    }
    /* OPENCLAW DAWN-1 DIRECT CUSTOMEOW ENTRY 20260729 END */

    $$('[data-nel-jump-primary]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        if (openCustomeow()) return;
        if (primaryForm) {
          primaryForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
          primaryForm.setAttribute('tabindex', '-1');
          window.setTimeout(() => primaryForm.focus({ preventScroll: true }), 320);
        }
        window.setTimeout(openCustomeow, 700);
        window.setTimeout(openCustomeow, 1500);
      });
    });
  };

  const loadAll = (context = document) => {
    context.querySelectorAll('[data-nel-pdp]').forEach(init);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => loadAll());
  } else {
    loadAll();
  }
  document.addEventListener('shopify:section:load', (event) => loadAll(event.target));
})();
